import { render, staticRenderFns } from "./moemoe.vue?vue&type=template&id=648d4907"
import script from "./moemoe.vue?vue&type=script&lang=js"
export * from "./moemoe.vue?vue&type=script&lang=js"
import style0 from "./moemoe.vue?vue&type=style&index=0&id=648d4907&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports